export const AUTH_STRINGS = {
  'first.name': 'First Name',
  'last.name': 'Last Name',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  'get.started': 'Get Started',
  'sign.up.sign.in.title': 'Enter your details and\u00a0receive...',
  'sign.up.sign.in.belong.x.title': 'Join 2,100 homeowners',
  'sign.up.sign.in.belong.x.subtitle': 'receiving missed payments protection.',
  'benefit.vacancy': '66% less vacancy.',
  'benefit.payments': 'guaranteed rent payments.',
  'benefit.care': 'exceptional care.',
  'benefit.inspection': 'a complimentary Inspection.',
  'benefit.pricing': 'a complimentary pricing\u00a0report.',
  'sign.up': 'Sign Up',
  'sign.in': 'Sign In',
  or: 'Or',
  'terms.first.line': "By continuing, I agree to Belong's",
  'terms.privacy': 'PRIVACY POLICY',
  'terms.and': 'and',
  'terms.tos': 'TERMS OF SERVICE',
  'sms.consent.line1':
    'I agree to receive recurring text messages from Belong at the mobile number provided. Message frequency varies. Message and data rates may apply.',
  'sms.consent.line2':
    "Reply STOP to cancel, HELP for help. I agree to Belong's",
  questions: 'Questions?',
  'sign.in.error.credentials': 'Invalid Email/Password',
  'sign.in.title': 'Sign In To Belong',
  'sign.in.forgot.password': 'FORGOT PASSWORD',
  'error.generic': 'Something went wrong!',
  'error.facebook':
    "Looks like your Facebook account doesn't match. Please create an account with the email below.",
  'error.google': 'Please allow 3rd party cookies to login with Google.',
  'error.email_taken':
    'Unable to register. Please sign in or use Forgot Password to recover access.',
};
